/**
 * Work experience editor indentation (Tailwind).
 * Role header uses a leading drag column (w-5 + gap-2 ≈ pl-7).
 * Bullets sit one nesting level below role metadata: pl-7 on the bullets block
 * plus each bullet row’s own drag + gap (≈ ml-12 on “+ Add Bullet”).
 */

/** Align bullets under role title/dates, not under the role drag handle column. */
export const WX_BULLETS_BLOCK_CLASS = 'space-y-2 mt-2 pt-1 pl-7'

/** Align “+ Add Bullet” with bullet text (after bullet drag + gap + checkbox). */
export const WX_ADD_BULLET_BUTTON_CLASS = 'ml-12 text-xs text-interactive hover:text-brand-primary font-medium'
